/* eslint-disable camelcase */

import { SourcingService, SourcingStageType } from 'api-clients/monolith';

type UpdateStageMappingsParams = {
  openingSlug: string;
  requestBody: {
    stages: Array<{
      stage_type: SourcingStageType;
      title: string;
      stage_id: string;
      expected_conversion: number | null;
      is_automated: boolean;
    }>;
  };
};

export function updateStageMappings(params: UpdateStageMappingsParams) {
  const { openingSlug, requestBody } = params;

  return SourcingService.patchInternalApiSourcingOpeningsMapSourcingStages(
    openingSlug,
    requestBody,
  );
}
